import * as CONSTANTS from "./constants";
import { APICLIENT } from "../../../shared";

export const resetPassword = (data) => async (dispatch, getState) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post("/Account/ResetPassword", data);
    const res = APICLIENT.handleResponse(response);
    if (res?.isSuccess) {
      dispatch({ type: CONSTANTS.PASSWORD_UPDATE, payload: response?.data });
    } else {
      dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
    }
    return res;
  } catch (err) {
    dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
    return APICLIENT.handleError(err);
  }
};
